import React from "react";
import Button from "../../shared/components/Button";
import CreditCard from "../../shared/CreditCard";
import { useTranslation } from 'react-i18next';

const buildButton = (label, theme, action) => {
  return (
    <div className="buttons">
      <Button label={label} onClick={action}
        theme={theme} />
    </div>);
}

const CreditCardPaymentMethod = (props) => {
  const { t } = useTranslation("common");
  if (!props.show) return null;

  const card = props.defaultPaymentMethod;
  let element = null;
  let label = "";
  let action = null;

  if (props.defaultPaymentMethod) {
    label = t("credit_card.edit");
    action = props.onChangeCard;
    
    element = (
      <CreditCard key={card.get("paymentMethodId")}
        card={card} onDelete={props.onDeleteCard}
      />
    );
  } else {
    label = t("credit_card.add");
    action = props.onAddCard;

    element = <p className="helptext">{t("credit_card.no_credit_card")}</p>;
  }

  const button = action && buildButton(label, Button.THEMES.BLUE_OUTLINE, action);

  return (
    <div className="CreditCardPaymentMethod">
      { element }
      { button }
    </div>
  );
}

CreditCardPaymentMethod.defaultProps = {
  usePrimaryButtonForAdd: true,
  show: true
}

export default CreditCardPaymentMethod;